var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"display":"grid","grid-template-columns":"2fr 1fr"}},[_vm._l((_vm.countData),function(c,idx){return [_c('div',{key:c.platform},[_vm._v(_vm._s(c.platform))]),_c('div',{key:idx},[_vm._v(_vm._s(_vm._f("formattedNumber")(c.count)))])]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }